export const organizationInfo = {
  name: "Kelab Kemajuan Insan Malaysia",
  shortName: "KKIM",
  registrationNo: "PPM-002-14-31032015",
  act: "Seksyen 7, Akta Pertubuhan 1966",
  address: "No. 18-2, Jalan Damai Perdana 6/2, Bandar Damai Perdana, 56000 Kuala Lumpur",
  domain: "kelabkemajuaninsan.org",
  email: "info@kelabkemajuaninsan.org",
  phone: "+60 3-8961 2345",
};

export const impactStats = [
  { id: 1, value: "3,200+", label: "Keluarga Dibantu", icon: "ri-home-heart-line" },
  { id: 2, value: "RM 1.8M", label: "Dana Disalurkan", icon: "ri-hand-coin-line" },
  { id: 3, value: "850+", label: "Sukarelawan Aktif", icon: "ri-team-line" },
  { id: 4, value: "11 Tahun", label: "Berkhidmat", icon: "ri-award-line" },
];

export const programs = [
  {
    id: 1,
    title: "Bantuan Kecemasan & Bencana",
    category: "Kemanusiaan",
    description:
      "Bantuan segera kepada mangsa banjir, kebakaran dan bencana alam dengan keperluan asas, makanan dan tempat perlindungan sementara.",
    icon: "ri-flood-line",
    raised: 48000,
    goal: 60000,
    image:
      "https://readdy.ai/api/search-image?query=Volunteers%20in%20matching%20green%20vests%20distributing%20relief%20supplies%20and%20food%20boxes%20to%20families%20affected%20by%20flood%20at%20a%20community%20shelter%20in%20Malaysia%2C%20warm%20hopeful%20atmosphere%2C%20soft%20natural%20light%2C%20editorial%20documentary%20photography%20with%20gentle%20depth%20of%20field%20and%20clean%20warm%20composition&width=800&height=600&seq=program-bantuan-bencana-01&orientation=landscape",
  },
  {
    id: 2,
    title: "Pendidikan Anak Yatim & Asnaf",
    category: "Pendidikan",
    description:
      "Menyokong persekolahan anak-anak yatim dan asnaf melalui bantuan yuran, alat tulis, tuisyen percuma dan biasiswa kecemerlangan.",
    icon: "ri-book-open-line",
    raised: 32000,
    goal: 45000,
    image:
      "https://readdy.ai/api/search-image?query=Malaysian%20children%20in%20school%20uniforms%20smiling%20and%20studying%20together%20at%20a%20bright%20community%20learning%20center%20with%20books%20and%20stationery%20on%20wooden%20tables%2C%20warm%20natural%20window%20light%2C%20hopeful%20educational%20atmosphere%2C%20editorial%20photography%20with%20soft%20warm%20tones&width=800&height=600&seq=program-pendidikan-02&orientation=landscape",
  },
  {
    id: 3,
    title: "Bantuan Makanan & Barangan Asas",
    category: "Kebajikan",
    description:
      "Pengagihan bakul makanan dan barangan keperluan asas kepada keluarga berpendapatan rendah dan golongan warga emas setiap bulan.",
    icon: "ri-restaurant-line",
    raised: 25000,
    goal: 30000,
    image:
      "https://readdy.ai/api/search-image?query=Volunteers%20packing%20grocery%20baskets%20filled%20with%20rice%20oil%20and%20canned%20food%20for%20distribution%20to%20low%20income%20families%20at%20a%20community%20hall%20in%20Malaysia%2C%20organized%20and%20caring%20atmosphere%2C%20warm%20soft%20lighting%2C%20editorial%20documentary%20photography%20with%20clean%20warm%20composition&width=800&height=600&seq=program-makanan-03&orientation=landscape",
  },
  {
    id: 4,
    title: "Program Kesihatan Komuniti",
    category: "Kesihatan",
    description:
      "Saringan kesihatan percuma, kempen kesedaran dan bantuan perubatan untuk komuniti kurang berkemampuan di sekitar Lembah Klang.",
    icon: "ri-heart-pulse-line",
    raised: 18000,
    goal: 35000,
    image:
      "https://readdy.ai/api/search-image?query=Medical%20volunteers%20conducting%20free%20health%20screening%20and%20blood%20pressure%20checks%20for%20elderly%20community%20members%20at%20a%20clean%20bright%20community%20clinic%20in%20Malaysia%2C%20compassionate%20caring%20atmosphere%2C%20soft%20natural%20light%2C%20editorial%20documentary%20photography%20with%20warm%20tones&width=800&height=600&seq=program-kesihatan-04&orientation=landscape",
  },
  {
    id: 5,
    title: "Bantuan Khas Ramadan & Raya",
    category: "Kebajikan",
    description:
      "Agihan sumbangan raya, duit raya untuk anak-anak asnaf, dan juadah berbuka puasa sepanjang bulan Ramadan yang mulia.",
    icon: "ri-gift-line",
    raised: 40000,
    goal: 50000,
    image:
      "https://readdy.ai/api/search-image?query=Volunteers%20distributing%20festive%20gift%20packets%20and%20duit%20raya%20to%20children%20from%20underprivileged%20families%20during%20Ramadan%20celebration%20in%20Malaysia%2C%20joyful%20warm%20festive%20atmosphere%20with%20decorations%2C%20soft%20golden%20light%2C%20editorial%20documentary%20photography%20with%20warm%20tones&width=800&height=600&seq=program-ramadan-05&orientation=landscape",
  },
  {
    id: 6,
    title: "Khidmat Sukarelawan",
    category: "Komuniti",
    description:
      "Program sukarelawan berterusan untuk membersihkan kawasan, membina rumah asnaf, dan membantu komuniti orang asli serta warga emas.",
    icon: "ri-hand-heart-line",
    raised: 12000,
    goal: 25000,
    image:
      "https://readdy.ai/api/search-image?query=Diverse%20group%20of%20Malaysian%20volunteers%20in%20green%20t%20shirts%20working%20together%20cleaning%20and%20renovating%20a%20village%20community%20house%20on%20a%20sunny%20day%2C%20spirit%20of%20teamwork%20and%20unity%2C%20warm%20natural%20sunlight%2C%20editorial%20documentary%20photography%20with%20clean%20warm%20composition&width=800&height=600&seq=program-sukarelawan-06&orientation=landscape",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Puan Rosnah binti Ahmad",
    role: "Penerima Bantuan — Klang",
    quote:
      "Bantuan makanan bulanan dari Kelab Kemajuan Insan Malaysia sangat meringankan beban keluarga saya selepas suami hilang pekerjaan. Terima kasih yang tidak terhingga.",
    initials: "RA",
  },
  {
    id: 2,
    name: "Encik Hafiz bin Ismail",
    role: "Sukarelawan — Kuala Lumpur",
    quote:
      "Menyertai program sukarelawan di sini memberi saya makna baru. Setiap misi bantuan mengingatkan saya bahawa rezeki perlu dikongsi bersama.",
    initials: "HI",
  },
  {
    id: 3,
    name: "Cik Nurul Ain",
    role: "Penaja Korporat — Selangor",
    quote:
      "Kami percaya dana yang disalurkan digunakan dengan penuh amanah dan telus. Laporan aktiviti yang jelas memberi keyakinan untuk terus menyumbang.",
    initials: "NA",
  },
];

export const bankAccount = {
  bankName: "Ambank",
  accountName: "Kelab Kemajuan Insan Malaysia",
  accountNumber: "8881 0234 4727 2",
  referenceNote: "Sila nyatakan 'DERMA' pada rujukan transaksi anda.",
};